import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { forwardRef } from 'react';

// Keyboard icon from Figma, used in the Display settings "Keyboard shortcuts" row.
const KeyboardShortcutsIcon = forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon ref={ref} viewBox="0 0 18 12" {...props}>
      <path
        d="M2.25 12H15.75C16.9926 11.9989 17.9989 11.0231 18 9.81818V2.18182C17.9989 0.976909 16.9926 0.00106364 15.75 0H2.25C1.00744 0.00106527 0.00109687 0.976909 0 2.18182V9.81818C0.00109856 11.0231 1.00744 11.9989 2.25 12ZM1.125 2.18182C1.1261 1.57991 1.62928 1.09197 2.25 1.09091H15.75C16.3707 1.09197 16.8739 1.57991 16.875 2.18182V9.81818C16.8739 10.4201 16.3707 10.908 15.75 10.9091H2.25C1.62928 10.908 1.1261 10.4201 1.125 9.81818V2.18182Z"
        fill="currentColor"
      />
      <path
        d="M8.61328 5.88927H9.38672C9.54163 5.88927 9.66797 6.03949 9.66797 6.162V6.912C9.66797 7.06221 9.54163 7.18473 9.38672 7.18473H8.61328C8.45837 7.18473 8.33203 7.03451 8.33203 6.912V6.162C8.33203 6.01179 8.45837 5.88927 8.61328 5.88927Z"
        fill="currentColor"
      />
      <path
        d="M6.11719 8.49709H11.8828C12.0377 8.49709 12.1641 8.6473 12.1641 8.76982V9.51982C12.1641 9.67003 12.0377 9.79254 11.8828 9.79254H6.11719C5.96228 9.79254 5.83594 9.64233 5.83594 9.51982V8.76982C5.83594 8.6196 5.96228 8.49709 6.11719 8.49709Z"
        fill="currentColor"
      />
      <path
        d="M5.92369 5.88927H6.69712C6.85203 5.88927 6.97837 6.03949 6.97837 6.162V6.912C6.97837 7.06221 6.85203 7.18473 6.69712 7.18473H5.92369C5.76878 7.18473 5.64244 7.03451 5.64244 6.912V6.162C5.64244 6.01179 5.76878 5.88927 5.92369 5.88927Z"
        fill="currentColor"
      />
      <path
        d="M3.23438 5.88927H4.00781C4.16272 5.88927 4.28906 6.03949 4.28906 6.162V6.912C4.28906 7.06221 4.16272 7.18473 4.00781 7.18473H3.23438C3.07947 7.18473 2.95312 7.03451 2.95312 6.912V6.162C2.95312 6.01179 3.07947 5.88927 3.23438 5.88927Z"
        fill="currentColor"
      />
      <path
        d="M13.9922 5.88927H14.7656C14.9205 5.88927 15.0469 6.03949 15.0469 6.162V6.912C15.0469 7.06221 14.9205 7.18473 14.7656 7.18473H13.9922C13.8373 7.18473 13.7109 7.03451 13.7109 6.912V6.162C13.7109 6.01179 13.8373 5.88927 13.9922 5.88927Z"
        fill="currentColor"
      />
      <path
        d="M11.3029 5.88927H12.0763C12.2312 5.88927 12.3576 6.03949 12.3576 6.162V6.912C12.3576 7.06221 12.2312 7.18473 12.0763 7.18473H11.3029C11.148 7.18473 11.0216 7.03451 11.0216 6.912V6.162C11.0216 6.01179 11.148 5.88927 11.3029 5.88927Z"
        fill="currentColor"
      />
      <path
        d="M8.61328 3.12791H9.38672C9.54163 3.12791 9.66797 3.27812 9.66797 3.40064V4.15064C9.66797 4.30085 9.54163 4.42336 9.38672 4.42336H8.61328C8.45837 4.42336 8.33203 4.27315 8.33203 4.15064V3.40064C8.33203 3.25042 8.45837 3.12791 8.61328 3.12791Z"
        fill="currentColor"
      />
      <path
        d="M5.92369 3.12791H6.69712C6.85203 3.12791 6.97837 3.27812 6.97837 3.40064V4.15064C6.97837 4.30085 6.85203 4.42336 6.69712 4.42336H5.92369C5.76878 4.42336 5.64244 4.27315 5.64244 4.15064V3.40064C5.64244 3.25042 5.76878 3.12791 5.92369 3.12791Z"
        fill="currentColor"
      />
      <path
        d="M3.23438 3.12791H4.00781C4.16272 3.12791 4.28906 3.27812 4.28906 3.40064V4.15064C4.28906 4.30085 4.16272 4.42336 4.00781 4.42336H3.23438C3.07947 4.42336 2.95312 4.27315 2.95312 4.15064V3.40064C2.95312 3.25042 3.07947 3.12791 3.23438 3.12791Z"
        fill="currentColor"
      />
      <path
        d="M13.9922 3.12791H14.7656C14.9205 3.12791 15.0469 3.27812 15.0469 3.40064V4.15064C15.0469 4.30085 14.9205 4.42336 14.7656 4.42336H13.9922C13.8373 4.42336 13.7109 4.27315 13.7109 4.15064V3.40064C13.7109 3.25042 13.8373 3.12791 13.9922 3.12791Z"
        fill="currentColor"
      />
      <path
        d="M11.3029 3.12791H12.0763C12.2312 3.12791 12.3576 3.27812 12.3576 3.40064V4.15064C12.3576 4.30085 12.2312 4.42336 12.0763 4.42336H11.3029C11.148 4.42336 11.0216 4.27315 11.0216 4.15064V3.40064C11.0216 3.25042 11.148 3.12791 11.3029 3.12791Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
});

export default KeyboardShortcutsIcon;
